import { faExternalLink } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { marked } from 'marked';
import { memo } from 'react';

import RenderHTML from '@/components/RenderHTML/RenderHTML';
import DualTime from '@/ui/components/DualTime/DualTime';
import formatStaffName from '@/utils/formatStaffName';
import { kustomerEventLink } from '@/utils/kustomerLinks';

import type { KustomerNoteCardProps } from './types';

const KustomerNoteCard = ({
  note,
  host,
  personKustomerId,
  memberTimeZone
}: KustomerNoteCardProps) => {
  if (!note.body) return null;

  const createdAt = note.kustomer_created_at || note.kustomer_updated_at;
  const kustomerNoteUrl =
    personKustomerId && note.kustomer_id
      ? kustomerEventLink({ host, kustomerId: note.kustomer_id, personKustomerId })
      : null;
  const renderedBody = marked.parse(note.body, { async: false, breaks: true, gfm: true });

  return (
    <div className="border border-gray-200 rounded p-3 mb-2 bg-gray-50">
      <RenderHTML html={renderedBody} />

      <p className="text-xs text-gray-500">
        Kustomer Note
        {kustomerNoteUrl && (
          <a
            aria-label="View Kustomer note"
            className="ml-1 text-gray-600 hover:text-gray-900"
            href={kustomerNoteUrl}
            rel="noreferrer"
            target="_blank">
            <FontAwesomeIcon icon={faExternalLink} />
          </a>
        )}
        {createdAt && (
          <>
            {' '}
            created <DualTime dateTime={new Date(createdAt)} memberTZ={memberTimeZone} />
          </>
        )}
        {note.created_by && <span> by {formatStaffName({ staff: note.created_by })}</span>}
      </p>
    </div>
  );
};

export default memo(KustomerNoteCard);
